import { Container, Grid, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import StationTrainingCard from '../Cards/StationTrainingCard';
import Icon1 from '../../Assets/Arena/estacoes/user-circle-plus-solid.svg';
import Icon2 from '../../Assets/Arena/estacoes/user-group-duotone-solid.svg';
import Icon3 from '../../Assets/Arena/estacoes/user-doctor-solid.svg';
import ImageMobile from '../../Assets/Arena/estacoes/mobile-image.png';
import ImageDesktop from '../../Assets/Arena/estacoes/desktop-image.png';

const stations = [
	{
		icon: Icon1,
		title: 'Estação com convidado',
		description: [
			'Como aluno do Arena Hardwork, você pode convidar qualquer pessoa para fazer as estações com você, mesmo que não seja aluno Hardwork.',
			<>
				<br />
				<br />
			</>,
			'Você será o médico e sua dupla assumirá o papel de paciente.',
		],
	},
	{
		icon: Icon2,
		title: 'Estação em dupla',
		description: [
			'Conecte-se com outros alunos através de chamadas de vídeo e treine com mais de 200 estações com casos clínicos e checklists.',
			<>
				<br />
				<br />
			</>,
			'No final de cada caso, um vídeo explicativo do professor, com orientações da estação.',
		],
	},
	{
		icon: Icon3,
		title: 'Estação com instrutor',
		description: [
			'Estação individual e mentoria com instrutor revalidado.',
			<>
				<br />
				<br />
			</>,
			'Faz toda a diferença ter a vivência real de uma estação, recebendo orientações personalizadas de quem entende do assunto.',
		],
	},
];

export default function StationsTraining() {
    
	const classes = useStyles()

	return (
		<Container
			fixed
			maxWidth="xl"
			disableGutters={true}
			className={'revalida'}
		>
			<Grid
				container
				className="section"
				style={{
					margin: '0 auto',
					paddingTop: '40px',
				}}
			>
				<Grid container>
					<Grid
						container
						className="section"
						style={{ margin: '0 auto' }}
					>
						<Grid
							container
							item
							className={classes.container}
						>
							<Grid
								item
								xs={12}
								container
								style={{ marginBottom: 16 }}
							>
								<Typography
									className={classes.title}
									fontFamily={'Manrope'}
								>
									Treine estações do Revalida de todas as formas possíveis
								</Typography>
							</Grid>

							<Grid
								item
								xs={12}
								container
								className={classes.bannerContainer}
							>
								<img
									src={ImageDesktop}
									alt={'Estações do Revalida'}
									className={classes.bannerDesktop}
								/>

								<img
									src={ImageMobile}
									alt={'Estações do Revalida'}
									className={classes.bannerMobile}
								/>
							</Grid>

							<Grid
								xs={12}
								container
								item
								spacing={3}
								justifyContent={'space-between'}
							>
								{stations.map((item, index) => (
									<Grid
										item
										container
										xs={12}
										sm={12}
										md={4}
										key={index}
									>
										<StationTrainingCard {...item} />
									</Grid>
								))}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Container>
	);
}

const useStyles = makeStyles((theme) => ({
	container: {
		margin: '40px 0 64px !important',
		[theme.breakpoints.down('md')]: {
			margin: '24px 0 !important',
		},
	},
	title: {
		color: '#FCFCFC',
		fontSize: '2.5rem !important',
		fontWeight: 'bold !important',
		[theme.breakpoints.down('md')]: {
			lineHeight: 'unset !important',
		},
		[theme.breakpoints.down('sm')]: {
			fontSize: '1.6rem !important',
			lineHeight: 'unset !important',
		},
	},
	bannerContainer: {
		margin: '32px 0 24px',
		[theme.breakpoints.down('sm')]: {
			margin: '24px 0 16px',
		},
	},
	bannerMobile: {
		width: '100%',
		height: 'auto',
		display: 'none',
		[theme.breakpoints.down('md')]: {
			display: 'block',
		},
	},
	bannerDesktop: {
		width: '100%',
		height: 'auto',
		display: 'block',
		[theme.breakpoints.down('md')]: {
			display: 'none',
		},
	},
}));
